<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="onClose()" [disabled]="invalidating()" aria-label="Cerrar">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>

    <div class="modal-content">
      <div class="alert-icon">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32 4L4 56H60L32 4Z" fill="#E53935" stroke="#E53935" stroke-width="2"/>
          <path d="M32 20V36M32 44V46" stroke="white" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </div>

      <h2 class="modal-title">Sesión activa detectada</h2>

      <p class="modal-message">
        Actualmente tienes una sesión activa en otro dispositivo.
      </p>

      <div class="session-details">
        <p class="detail-item">
          <strong>Dispositivo:</strong> {{ sessionInfo.device }}
        </p>
        <p class="detail-item">
          <strong>Plataforma:</strong> {{ sessionInfo.platform }}
        </p>
      </div>

      @if (errorMessage()) {
        <div class="error-message" role="alert">
          {{ errorMessage() }}
        </div>
      }

      <div class="modal-actions">
        <button
          class="btn btn-primary"
          (click)="onContinue()"
          [disabled]="invalidating()"
          type="button">
          @if (invalidating()) {
            <span class="btn-spinner" aria-hidden="true"></span>
            Cerrando sesión anterior...
          } @else {
            Continuar e invalidar sesión
          }
        </button>
        <button
          class="btn btn-secondary"
          (click)="onCancel()"
          [disabled]="invalidating()"
          type="button">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
